import React from 'react';
import './pullQuote.scss';
import quoteIcon from '../../Assets/quoteIcon.svg';

const PullQuote = ({ quote, color, author, source }) => {
  return (
    <div className="pullQuote">
      <div className="pullQuote__text">
        <img src={quoteIcon} alt="quote graphic" />
        <p className="pq">{quote}</p>
        <p>
          <span className="authorBold">{author} </span>
          {source}
        </p>
      </div>
    </div>
  );
};

export default PullQuote;
